export default __webpack_public_path__ + "static/media/setting-icon.8ef07aa0.svg";